import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import {
    useUpdateCustomerMutation,
    useGetTaxwithholdingQuery,
    useGetTaxcategoryQuery,
    useGetContactQuery,
    useGetCustomerAddressesQuery,
    useGetIndustryTypeQuery,
    useGetMaketsegmentQuery,
    useGetBAnkAccountQuery,
    useGetPriceListQuery,
    useGetCustomerGroupsQuery,
    useGetTerritoryListQuery,
    useGetLeadListQuery,
    useGetAccoountmangerListQuery,
    useGetCurrencyListQuery,
    useGetCustomerDetailsMutation,
} from '../../../../store/api/customer';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import Tab6 from './Tab6'
import Attachment from '../../../../utils/Attachment';

function Customer() {
    const location = useLocation()
    const customerName = location?.state?.PurchaseId
    const navigate = useNavigate()
    const [tab, settab] = useState(1)
    const [res, setRes] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);

    const [customername, setCustoemrName] = useState('')
    const [customertype, setCustoemrtype] = useState('')
    const [mobile, setMobile] = useState('')
    const [customergrplist, setcustomerGrplist] = useState([])
    const [customergrp, setcustomerGrp] = useState('')
    const [terilist, setTeriList] = useState([])
    const [terittory, setTerittory] = useState('')
    const [leadlist, setleadlist] = useState([])
    const [lead, setlead] = useState('')
    const [accountlist, setAccountlist] = useState([])
    const [account, setAccount] = useState('')

    const [currencylist, setCurrencylist] = useState([])
    const [currency, setCurrency] = useState('')
    const [pricelist, setPricelist] = useState([])
    const [price, setPrice] = useState('')
    const [isGroup, setIsGroup] = useState(0);
    const [banklist, setBanklist] = useState([])
    const [bankAccount, setBankAccount] = useState('')

    const [marketList, setmarketlist] = useState([])
    const [market, setMarket] = useState('')
    const [industry, setIndustry] = useState('')
    const [industrylist, setIndustrylist] = useState([])
    const [website, setWebsite] = useState('')
    const [customerDetails, setCustomerDetails] = useState('')

    const [addaresslist, setAddresslist] = useState([])
    const [primaryadd, setPrimaryadd] = useState('')
    const [contactlist, setContaclist] = useState([])
    const [primarycontact, setPrimarycontact] = useState('')

    const [taxId, setTaxId] = useState('')
    const [taxcatlist, setTaxcatlist] = useState([])
    const [taxcategory, settaxCategory] = useState('')
    const [taxwithholdlist, setTaxwithHoldlist] = useState([])
    const [taxwithholds, setTaxwithholds] = useState('')
    const [gst, setGst] = useState('')
    const [pan, setPan] = useState('')
    const [gstCategory, setGstCategory] = useState('')

    const [salesorder, setSalerOrder] = useState(0)
    const [frozen, setFrozen] = useState(0)
    const [delivery, setDelivery] = useState(0)
    const [disable, setDisable] = useState(0)

    const { data: customerGroup, cserror, isLoading } = useGetCustomerGroupsQuery();
    const { data: territory, terror, tisLoading } = useGetTerritoryListQuery();
    const { data: leaddata, lerror, lisLoading } = useGetLeadListQuery();
    const { data: accnountdata, aerror, aisLoading } = useGetAccoountmangerListQuery();
    const { data: currencydata, cerror, cisLoading } = useGetCurrencyListQuery();
    const { data: priceData, perror, pisLoading } = useGetPriceListQuery();
    const { data: bankdata, berror, bisLoading } = useGetBAnkAccountQuery();
    const { data: marketData, merror, misLoading } = useGetMaketsegmentQuery();
    const { data: industryData, ierror, iisLoading } = useGetIndustryTypeQuery();
    const { data: addressdata, caerror, caisLoading } = useGetCustomerAddressesQuery();
    const { data: contactData, coerror, coisLoading } = useGetContactQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery();
    const { data: taxwithhold, taxerror, taxisLoading } = useGetTaxwithholdingQuery();
    const [updateCustomer] = useUpdateCustomerMutation();
    const [getCustomerDetails, { data: customerData, cuisLoading, cucerror }] = useGetCustomerDetailsMutation()

    useEffect(() => {
        getCustomerDetails({ customer_name: customerName });
        setCustoemrName(customerName)
    }, []);

    useEffect(() => {
        if (customerData?.result) {
            const data = customerData.result;
            setCustoemrName(data.customer_name || '');
            setCustoemrtype(data.customer_type || '');
            setMobile(data.mobile_no || '');
            setGst(data.gstin || '');
            setGstCategory(data.gst_category || '');
            setcustomerGrp(data.customer_group || '');
            setTerittory(data.territory || '');
            setlead(data.lead_name || '');
            setAccount(data.account_manager || '');
            setCurrency(data.default_currency || '');
            setPrice(data.default_price_list || '');
            setIsGroup(data.is_group || 0);
            setBankAccount(data.bank_account || '');
            setMarket(data.market_segment || '');
            setIndustry(data.industry || '');
            setWebsite(data.website || '');
            setCustomerDetails(data.customer_details || '');
            setPrimaryadd(data.primary_address || '');
            setPrimarycontact(data.mobile_no || '');
            setTaxId(data.tax_id || '');
            settaxCategory(data.tax_category || '');
            setTaxwithholds(data.tax_withholding_category || '');
            setPan(data.pan || '');
            setSalerOrder(data.so_required || 0);
            setFrozen(data.is_frozen || 0);
            setDelivery(data.dn_required || 0);
            setDisable(data.disabled || 0);
        }
    }, [customerData]);

    const handleSubmit = async () => {
        const payload = {
            customer_name: customername,
            customer_type: customertype,
            mobile_no: mobile,
            customer_group: customergrp,
            territory: terittory,
            lead_name: lead,
            account_manager: account,
            default_currency: currency,
            default_price_list: price,
            is_internal_customer: isGroup,
            industry: industry,
            market_segment: market,
            website: website,
            customer_details: customerDetails,
            customer_primary_address: primaryadd,
            customer_primary_contact: primarycontact,
            tax_id: taxId,
            tax_category: taxcategory,
            tax_withholding_category: taxwithholds,
            gstin: gst,
            pan: pan,
            gst_category: gstCategory,
            so_required: salesorder,
            dn_required: delivery,
            is_frozen: frozen,
            disabled: disable
        };
        try {
            const response = await updateCustomer(payload).unwrap();
            console.log('Customer updated:', response);
            setError('Customer updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/customer/customer-list')
            }, 2000);
        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setShowError(true);
        }
    };

    useEffect(() => {
        if (taxwithhold) {
            setTaxwithHoldlist(taxwithhold.data)
        }
    }, [taxwithhold])

    useEffect(() => {
        if (taxcatData) {
            setTaxcatlist(taxcatData.data)
        }
    }, [taxcatData])

    useEffect(() => {
        if (contactData) {
            setContaclist(contactData.data)
        }
    }, [contactData])

    useEffect(() => {
        if (addressdata) {
            setAddresslist(addressdata.data)
        }
    }, [addressdata])

    useEffect(() => {
        if (industryData) {
            setIndustrylist(industryData.data)
        }
    }, [industryData])

    useEffect(() => {
        if (marketData) {
            setmarketlist(marketData.data)
        }
    }, [marketData])

    useEffect(() => {
        if (bankdata) {
            setBanklist(bankdata.data)
        }
    }, [bankdata])

    useEffect(() => {
        if (priceData) {
            setPricelist(priceData.data)
        }
    }, [priceData])

    useEffect(() => {
        if (currencydata) {
            setCurrencylist(currencydata.data)
        }
    }, [currencydata])

    useEffect(() => {
        if (accnountdata) {
            setAccountlist(accnountdata.data)
        }
    }, [accnountdata])

    useEffect(() => {
        if (customerGroup) {
            setcustomerGrplist(customerGroup.data)
        }
    }, [customerGroup])

    useEffect(() => {
        if (territory) {
            setTeriList(territory.data)
        }
    }, [territory])

    useEffect(() => {
        if (leaddata) {
            setleadlist(leaddata.data)
        }
    }, [leaddata])

    const customertypelist = [
        { "name": 'Company' },
        { "name": 'Individual' },
        { "name": 'Partnership' },
    ];

    const GstCategorylist = [
        { "name": "Unregisterd" },
        { "name": "Registerd Composition" },
        { "name": "Registerd Regular" },
        { "name": "SEZ" },
        { "name": "Overseas" },
        { "name": "Deemed Exort" },
        { "name": "UIN Holders" },
        { "name": "Tax Deductors" },
        { "name": "Tax Collectors" },
        { "name": "Input Service Distributor" },
    ]
    return (
        <>
            <FormLayout
                title="View Customer"
                breadcrumbs={[
                    { label: "Customer" },
                    { label: "Customer List", url: "/master/customer/customer-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>

                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            onClick={handleSubmit}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 4 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(4) }} href="javascript:void(0);">
                                        Address & Contact{tab == 4 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 5 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(5) }} href="javascript:void(0);">
                                        Tax{tab == 5 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 6 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(6) }} href="javascript:void(0);">
                                        Settings{tab == 6 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                              <Attachment doctype="Customer"  docname={customerName}  />    
                        </div>
                    </div>
                    <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12">
                                <div className="sidebarbox m-0 px-4 py-2">
                                    {tab === 1 && (
                                        <Tab1
                                            customertypelist={customertypelist}
                                            setCustoemrtype={setCustoemrtype}
                                            customertype={customertype}
                                            setCustoemrName={setCustoemrName}
                                            customername={customername}
                                            setMobile={setMobile}
                                            mobile={mobile}
                                            customergrplist={customergrplist}
                                            setcustomerGrp={setcustomerGrp}
                                            customergrp={customergrp}
                                            terittory={terittory}
                                            setTerittory={setTerittory}
                                            terilist={terilist}
                                            lead={lead}
                                            setlead={setlead}
                                            leadlist={leadlist}
                                            accountlist={accountlist}
                                            account={account}
                                            setAccount={setAccount}
                                            currency={currency}
                                            setCurrency={setCurrency}
                                            currencylist={currencylist}
                                            price={price}
                                            setPrice={setPrice}
                                            pricelist={pricelist}
                                            setIsGroup={setIsGroup}
                                            isGroup={isGroup}
                                            setBankAccount={setBankAccount}
                                            bankAccount={bankAccount}
                                            banklist={banklist}
                                            setMarket={setMarket}
                                            market={market}
                                            marketList={marketList}
                                            industry={industry}
                                            setIndustry={setIndustry}
                                            industrylist={industrylist}
                                            website={website}
                                            setWebsite={setWebsite}
                                            customerDetails={customerDetails}
                                            setCustomerDetails={setCustomerDetails}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12">
                                <div className="sidebarbox m-0 px-4 ">
                                    {tab === 4 && (
                                        <Tab4
                                            customerName={customerName}
                                            primaryadd={primaryadd}
                                            setPrimaryadd={setPrimaryadd}
                                            addaresslist={addaresslist}
                                            contactlist={contactlist}
                                            primarycontact={primarycontact}
                                            setPrimarycontact={setPrimarycontact}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between">
                            <div className="col-12">
                                <div className="sidebarbox m-0 px-4 ">
                                    {tab === 5 && (
                                        <Tab5
                                            customerName={customerName}
                                            price={price}
                                            setPrice={setPrice}
                                            pricelist={pricelist}
                                            taxId={taxId}
                                            setTaxId={setTaxId}
                                            settaxCategory={settaxCategory}
                                            taxcategory={taxcategory}
                                            taxcatlist={taxcatlist}
                                            taxwithholdlist={taxwithholdlist}
                                            setTaxwithholds={setTaxwithholds}
                                            taxwithholds={taxwithholds}
                                            setGst={setGst}
                                            gst={gst}
                                            setPan={setPan}
                                            pan={pan}
                                            GstCategorylist={GstCategorylist}
                                            gstCategory={gstCategory}
                                            setGstCategory={setGstCategory}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-between" style={{ flexGrow: '1' }}>
                            <div className="col-12">
                                <div className="sidebarbox m-0 px-4 ">
                                    {tab === 6 && (
                                        <Tab6
                                            customerName={customerName}
                                            setDisable={setDisable}
                                            disable={disable}
                                            setDelivery={setDelivery}
                                            delivery={delivery}
                                            setFrozen={setFrozen}
                                            frozen={frozen}
                                            setSalerOrder={setSalerOrder}
                                            salesorder={salesorder}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayout>
        </>
    )
}

export default Customer